import React from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const PagerArrowButton = ({
  direction = "next",
  isRtl = false,
  disabled = false,
  onClick,
  ariaLabel,
  className = "",
}) => {
  const showBack = direction === "prev" ? !isRtl : isRtl;
  const Icon = showBack ? IoIosArrowBack : IoIosArrowForward;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel || (direction === "prev" ? "Previous page" : "Next page")}
      className={`pager-icon-btn ${className}`.trim()}
    >
      <Icon size={18} />
    </button>
  );
};

export default PagerArrowButton;
